import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { EPlacingType, IPublishOption } from '../../redux/reducers';
import { selectServiceById } from './selectServiceById';

export const selectActiveOptionByServiceId = curry((serviceId: string, state: IAppState): IPublishOption | null => {
  const service = selectServiceById(serviceId, state);

  const {
    publishOptions: { packages, selectedPackageId, periods, selectedPeriodId, selectedPlacingType },
  } = service;

  if (selectedPlacingType === EPlacingType.package && selectedPackageId) {
    return packages[selectedPackageId];
  }

  if (selectedPlacingType === EPlacingType.balance && selectedPeriodId) {
    return periods[selectedPeriodId];
  }

  return null;
});
